module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/todays-closed-tickets/todays-closed-tickets.component.css
// module id = ./src/app/reports/todays-closed-tickets/todays-closed-tickets.component.css
// module chunks = main